import React from "react";
import { IGameStatisticsClass } from "@/types/StatisticsTypes";

//Note: key naming convention per 08-04-2019
//	[pcode]gs[t|b]_[number]
//Example:
//	m16gst_0

//[pcode]: game pcode
//[t|b]: top or bottom
//[number]: number from 0, starting from the top of filtrate function

function processStatisticsPercentage(key: string, count: number, total: number) {
	return <div key={key} className="desc-content">
		{Math.round(count / total * 100) + "%"}
	</div>;
}

function renderStatistics(statisticsClass: IGameStatisticsClass) {
	statisticsClass.statisticsArray = {top: [], bottom: []};
	for (const key in statisticsClass.props.filters)
		statisticsClass.filtrate(
			statisticsClass.props.history,
			statisticsClass.props.filters[key]
		);
	
	return (
		<div className="game-statistics">
			<div className="new-statistics top">
				{ statisticsClass.statisticsArray.top }
			</div>
			<div className="new-statistics">
				{ statisticsClass.statisticsArray.bottom }
			</div>
		</div>
	);
}

function renderm7Statistics(statisticsClass: IGameStatisticsClass) {
	statisticsClass.statisticsArray = {top: [], bottom: []};

	statisticsClass.filtrate(statisticsClass.props.history, "");

	return (
		<div className="game-statistics m7">
			<div className="new-statistics top">
				{ statisticsClass.statisticsArray.top }
			</div>
			<div className="new-statistics">
				{ statisticsClass.statisticsArray.bottom }
			</div>
		</div>
	);
}


function renderm25Statistics(statisticsClass: IGameStatisticsClass) {
	statisticsClass.statisticsArray = {top: [], bottom: []};

	statisticsClass.filtrate(statisticsClass.props.history, "");

	return (
		<div className="game-statistics m25">
			<div className="new-statistics top">
				{ statisticsClass.statisticsArray.top }
			</div>
			<div className="new-statistics">
				{ statisticsClass.statisticsArray.bottom }
			</div>
		</div>
	);
}

function beadJSX(shape: "circle" | "circle-hollow" | "", colour: string, letter: string, pair: "banker" | "player" = null) {
	return (
		<div className={
			(shape === "" ? "" : "sl-roadmap-" + shape) +
			(colour === "" ? "" : " sl-roadmap-" + colour)}>
			<div className={
				(pair ? "sl-baccarat-" + pair + "-pair" : "") +
				(pair ? " sl-roadmap-" + colour : "") + 

				(
					shape === "circle" ? " sl-baccarat-bead-value" :
					shape === "circle-hollow" ? " sl-hollow-value" : ""
				)
				}>
				{letter}
			</div>
		</div>
	);
}

function processMultilineStatistics(
		statisticsArrayOutput: JSX.Element[],
		statisticsCells: {top: JSX.Element[], bottom: JSX.Element[]},
		cellsPerLine: number,
		isPortrait: boolean,
		pcode: string
	) {

	if (isPortrait)
		for (let a = 0; a < Math.round(statisticsCells.top.length / cellsPerLine); a++)
		statisticsArrayOutput.push(...[
				//Top
				<tr key={"gs_" + pcode + "_1_" + a}>
					{
						statisticsCells.top
							.slice(a * cellsPerLine, (a + 1) * cellsPerLine)
							.map((ele, eleIdx) =>
							<td key={"gs_m27_" + a + "_" + eleIdx}>
								{ele}
							</td>	
						)
					}
				</tr>,

				//Bottom
				<tr key={"gs_" + pcode + "_2_" + a}>
					{
						statisticsCells.bottom
							.slice(a * cellsPerLine, (a + 1) * cellsPerLine)
							.map((ele, eleIdx) =>
							<td key={"gs_m27_" + a + "_" + eleIdx}>
								{ele}
							</td>	
						)
					}
				</tr>
			]);
	else statisticsArrayOutput.push(...[
		//Top
		<tr key={"gs_" + pcode + "_1"}>
			{
				statisticsCells.top.map((ele, eleIdx) =>
				<td key={"gs_" + pcode + "_1_" + eleIdx}>
					{ele}
				</td>
				)
			}
		</tr>,

		//Bottom
		<tr key={"gs_" + pcode + "_2"}>
			{
				statisticsCells.bottom.map((ele, eleIdx) =>
				<td key={"gs_" + pcode + "_2_" + eleIdx}>
					{ele}
				</td>
				)
			}
		</tr>
	]);
}


export {
	processStatisticsPercentage,
	renderStatistics,
	renderm7Statistics,
	renderm25Statistics,

	beadJSX,
	processMultilineStatistics
};
